/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext } from 'react';
import { FormHelperText, InputLabel } from '@material-ui/core';

import type { FileObject } from '@klp/file/classes';
import { FileUpload } from '@klp/file/components';
import { FileGallery } from '@klp/file/views/FileGallery';

import { FormContext } from './FormContext';
import { useFormField, type IFormFieldProps } from './useFormField';

interface IFormFilesProps extends IFormFieldProps<Array<FileObject>> {
    path: string;
    queueName: string;
    mimeTypes: Array<string>;
}

export const FormFiles: React.FC<IFormFilesProps> = (props) => {
    const { name, value, path, title, queueName, mimeTypes } = props;

    const { getHelperText, context } = useFormField<Array<FileObject>>(props);

    // Attach values to remove from form and Message object/saga when saving
    const onChange = (
        qName: string,
        downloadQueue: Record<string, Record<string, FileObject>>,
        uploadQueue: Record<string, Array<FileObject>>,
    ) => {
        if (qName !== queueName) return;

        const queueFiles = downloadQueue[queueName] || {};
        const downloadFiles = Object.values(queueFiles);

        const uploadFiles = Object.values(uploadQueue)
            .flat()
            .filter((file) => mimeTypes.includes(file.type || ''));

        if (context?.setValue) {
            const allFiles = [...uploadFiles, ...downloadFiles];
            context.setValue(queueName, allFiles as unknown as string);
        }
    };

    return value ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            <InputLabel>{title}</InputLabel>
            <FileGallery
                source={value}
                allowedMimeTypes={mimeTypes}
                onChange={onChange}
                path={path}
                queueName={queueName}
                uploader={FileUpload}
                uploaderParams={{
                    mimeTypes,
                    queueName,
                    id: `${queueName}-${name}-uploader`,
                }}
                edit={true}
            />
            <FormHelperText>{getHelperText()}</FormHelperText>
        </>
    ) : null;
};
